import React from 'react'

const ClosedPassport = () => {
    return (
        <>
            <svg
                id="caffeineDreams"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 100 140"
                width={300}
            >
                <path
                    d="M0,0 h90 a10,10 0 0 1 10,10 v120 a10,10 0 0 1 -10,10 h-90z"
                    fill="#800000"
                />
                <text
                    textAnchor="middle"
                    fontFamily="sans-serif"
                    fill="goldenrod"
                    x={50}
                    y={25}
                    fontSize={13}
                >
                    PASSPORT
                </text>
                <circle
                    r={30}
                    cx={50}
                    cy={70}
                    fill="none"
                    stroke="goldenrod"
                    strokeWidth={3}
                />
                <circle
                    r={33}
                    cx={50}
                    cy={70}
                    fill="none"
                    stroke="goldenrod"
                    strokeWidth="0.5"
                />
                <path d="M32,45 a50,50 1,0 10,50" fill="none" stroke="goldenrod" />
                <path d="M68,45 a50,50 1,0 0 0,50" fill="none" stroke="goldenrod" />
                <path d="M20,70 h60" stroke="goldenrod" />
                <path d="M50,40 v60" stroke="goldenrod" />
                <rect x={40} y={110} ry={3} rx={3} width={20} height={10} fill="goldenrod" />
                <path d="M40,115 h20" stroke="#800000" />
                <circle r={3} cx={50} cy={115} fill="goldenrod" stroke="#800000" />
                <path d="M85,0 v150" strokeWidth={30} className="highlight" />
                <path d="M110,0 v150" strokeWidth={10} className="highlight" />
                <path d="M20,0 v150" strokeWidth={10} className="highlight" />
            </svg>

        </>
    )
}

export default ClosedPassport